<template>
	<svg :width="width" :height="height" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve">
		<g>
			<g> 
				<path :fill="color" d="
					M472.426,25.718v70.237c9.698,10.923,23.831,17.802,39.574,17.802V7.926 C496.258,7.926,482.124,14.805,472.426,25.718z
				"></path>
				<path :fill="color" d="
					M139.514,189.938c-3.988,7.235-1.367,16.323,5.877,20.32l173.514,95.686c7.235,3.978,16.333,1.348,20.33-5.887
					l6.926-12.571L146.44,177.368L139.514,189.938z
				"></path>
				<path :fill="color" d="
					M315.78,164.086l5.766-10.445c2.957-5.354,1.01-12.093-4.353-15.051l-29.361-16.193 
					c-5.364-2.958-12.102-1.01-15.05,4.352l-5.766,10.456c-41.623-11.298-86.392,1.357-115.913,32.684L350,279.559
					C360.726,237.87,347.547,193.261,315.78,164.086z
				"></path>
				<path :fill="color" d="
					M1.578,341.334c-3.38,6.15-1.152,13.872,4.989,17.26c6.149,3.388,13.871,1.151,17.26-4.989
					c3.388-6.14-0.197-25.955-0.197-25.955S4.966,335.194,1.578,341.334z
				"></path> 
				<path :fill="color" d="
					M66.825,377.314c-3.388,6.14-1.151,13.872,4.989,17.25c6.15,3.388,13.862,1.161,17.25-4.988
					c3.388-6.14-0.187-25.946-0.187-25.946S70.214,371.164,66.825,377.314z
				"></path>
				<path :fill="color" d="
					M132.063,413.283c-3.378,6.141-1.141,13.872,4.998,17.26c6.14,3.388,13.872,1.161,17.26-4.989
					c3.388-6.14-0.206-25.945-0.206-25.945C154.116,399.6,135.452,407.144,132.063,413.283z
				"></path>
				<path :fill="color" d="
					M197.321,449.264c-3.388,6.14-1.161,13.871,4.979,17.259c6.141,3.389,13.872,1.152,17.26-4.997
					c3.388-6.141-0.196-25.946-0.196-25.946S200.709,443.123,197.321,449.264z
				"></path> 
				<path :fill="color" d="
					M262.56,485.243c-3.39,6.14-1.161,13.871,4.988,17.25c6.14,3.388,13.871,1.151,17.259-4.989
					c3.38-6.141-0.196-25.946-0.196-25.946S265.948,479.102,262.56,485.243z
				"></path> 
				<path :fill="color" d="
					M71.618,317.775c6.14,3.388,13.871,1.151,17.26-4.988c3.388-6.15-0.196-25.955-0.196-25.955 
					s-18.664,7.544-22.052,13.684C63.25,306.665,65.478,314.387,71.618,317.775z
				"></path> 
				<path :fill="color" d="
					M136.865,353.755c6.14,3.388,13.862,1.151,17.25-4.998c3.388-6.14-0.187-25.945-0.196-25.945
					c0,0-18.654,7.544-22.043,13.684C128.488,342.636,130.716,350.367,136.865,353.755z
				"></path> 
				<path :fill="color" d="
					M202.113,389.724c6.14,3.389,13.862,1.161,17.25-4.988c3.388-6.14-0.196-25.946-0.196-25.946 
					s-18.664,7.534-22.052,13.684C193.726,378.615,195.964,386.336,202.113,389.724z
				"></path> 
				<path :fill="color" d="
					M267.352,425.704c6.14,3.38,13.871,1.152,17.259-4.989c3.389-6.14-0.205-25.945-0.205-25.945
					s-18.654,7.534-22.043,13.675C258.974,414.585,261.211,422.316,267.352,425.704z
				"></path> 
				<path :fill="color" d="
					M150.69,277.818c3.388-6.141-0.188-25.946-0.188-25.946s-18.663,7.536-22.051,13.685 c-3.388,6.15-1.16,13.871,4.979,17.25C139.58,286.195,147.302,283.968,150.69,277.818z
				"></path> 
				<path :fill="color" d="
					M215.938,313.798c3.388-6.141-0.196-25.946-0.196-25.946s-18.664,7.535-22.052,13.685 c-3.388,6.14-1.151,13.862,4.998,17.25C204.827,322.175,212.559,319.947,215.938,313.798z
				"></path> 
				<path :fill="color" d="
					M281.185,349.777c3.388-6.15-0.206-25.955-0.206-25.955s-18.663,7.544-22.052,13.684 c-3.379,6.14-1.142,13.872,4.998,17.26C270.066,358.154,277.797,355.917,281.185,349.777z
				"></path> 
				<path :fill="color" d="
					M363.253,56.381c-26.564,11.242-49.111,29.971-65.051,53.567c-0.608,0.899-1.188,1.816-1.778,2.734
					l25.721,14.171c0,0,0.009,0.01,0.018,0.018c8.573-12.832,19.581-23.924,32.367-32.553c18.944-12.795,41.679-20.237,66.287-20.255 h38.674V44.757h-38.674C400.43,44.757,380.943,48.894,363.253,56.381z
				"></path>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ShowerIcon',
	props: {
		width: {
			type: Number,
			default: 32,
		},
		height: {
			type: Number,
			default: 32,
		},
		color: {
			type: String,
			default: 'black',
		},
	},
}
</script>
